import { getCookie, setCookie } from "Functions/cookie";
import { updateLazy } from "Functions/lazy";

const $ = window.jQuery;

function updateWatchdogButtons(productId) {
    // Update all watchdog buttons for this product on the page
    $(".js-watchdog-btn").each(function () {
        var $button = $(this);
        var href = $button.data("href");

        // Check if this button is for the product we just added to watchdog
        if (href && href.includes("/custom-modal-watchdog-availability/" + productId)) {
            var textSet = $button.data("text-set");
            var textSetLong = $button.data("text-set-long");

            if (textSet) {
                $button.find(".sc-short").text(textSet);
            }
            if (textSetLong) {
                $button.find(".sc-long").text(textSetLong);
            }
        }
    });

    // Update product page watchdog button
    $(".js-watchdog-trigger").each(function () {
        var $button = $(this);
        var buttonProductId = $button.data("product-id");

        // Check if this button is for the product we just added to watchdog
        if (buttonProductId && String(buttonProductId) === String(productId)) {
            $button.addClass("is-watched");
            $button.find(".sc-text").text($button.data("text-watched") || "Sledované");
            $button.attr("title", $button.data("title-watched") || "Produkt je sledovaný");
        }
    });
}

window.checkNotificationType = function (elem) {
    const $price_input = $(".js-watchdog-price");

    let isCheaper = $(elem).val() == "become_cheaper";

    if (isCheaper) {
        $price_input.slideDown();
    } else {
        $price_input.slideUp();
    }
};

window.watchdogModalLoaded = function ($modal) {
    if (!$modal.hasClass("in")) {
        return;
    }
    $modal.addClass("is-loaded");

    // Initialize sliders in the modal
    $modal.find("r-slider").each(function (index) {
        const sliderElement = this;

        // Remove lazy attribute to allow initialization
        sliderElement.removeAttribute("r-slider-lazy");

        // Wait for next frame to ensure DOM is ready
        window.requestAnimationFrame(() => {
            if (sliderElement.swiper) {
                sliderElement.destroySlider();
            }

            if (sliderElement.buildSlider) {
                sliderElement.buildSlider();

                // Update lazy loading for images after slider is built
                window.requestAnimationFrame(() => {
                    updateLazy();
                });
            } else if (sliderElement.handleSlider) {
                sliderElement.handleSlider();
            }
        });
    });

    $(".js-form-modal-watchdog").validate({
        rules: {
            custom_customer_phone: {
                phone: true,
            },
            notification_price: {
                number: true,
            },
        },
        submitHandler: function (form) {
            $modal.find('[type="submit"]').prop("disabled", true);
            $(".js-watchdog-error").slideUp(100);
            $(".js-watchdog-success").slideUp(100);

            // Store form data for cookie handling
            var customerId = $(form).find('input[name="customer_id"]').val();
            var productId = $(form).find('input[name="product_id"]').val();

            window.assignRecaptchaResponseToForm(form).then(function () {
                Form.ajaxPost(
                    form,
                    function (data) {
                        $modal.find('[type="submit"]').prop("disabled", false);

                        if (!data.status) {
                            $(".js-watchdog-error").text(data.message).slideDown(200);
                        } else {
                            $(".js-watchdog-success").text(data.message).slideDown(200);
                            $(".js-watchdog-hide").slideUp(200);

                            // Handle storage for all users
                            if (productId) {
                                if (customerId) {
                                    // For logged users, make AJAX request to update session
                                    $.post("/watchdog/update-session", {
                                        action: "add",
                                        product_id: productId,
                                    });
                                } else {
                                    // For non-logged users, use cookie
                                    var cookieName = "watchdog_products";
                                    var watchdogProducts = getCookie(cookieName);
                                    var products = watchdogProducts
                                        ? JSON.parse(watchdogProducts)
                                        : [];

                                    // Add product if not already in array
                                    if (products.indexOf(productId) === -1) {
                                        products.push(productId);
                                        setCookie(cookieName, JSON.stringify(products), 365);
                                    }
                                }

                                // Update all watchdog buttons for this product on the page
                                updateWatchdogButtons(productId);
                            }
                        }
                    },
                    "json"
                );
            });
        },
    });

    checkNotificationType($("#notification_type"));

    $("#notification_type").on("change", function () {
        checkNotificationType($(this));
    });
};

// Track which thumb triggered the watchdog modal
let $watchdogTriggerThumb = null;

$(document).on("hidden.bs.modal", ".modal", function () {
    // If this was a watchdog modal and we have a tracked thumb, restore its hover state
    if ($(this).attr("id") === "watchdogModal" && $watchdogTriggerThumb) {
        $watchdogTriggerThumb.addClass("is-hovered");
        $watchdogTriggerThumb = null; // Clear the reference
    }
});

// Track which thumb triggered the watchdog modal
$(document).on("click", ".js-watchdog-btn", function () {
    $watchdogTriggerThumb = $(this).closest(".js-products-listing-item");
});

// Remove is-hovered class when clicking outside any thumb element
$(document).on("click", function (e) {
    // If the click is not on a thumb element or its children
    if (!$(e.target).closest(".js-products-listing-item").length) {
        $(".js-products-listing-item.is-hovered").removeClass("is-hovered");
    }
});
